import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Animated, Keyboard, TouchableOpacity, View} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {getApp} from '../../../../../actions/app';
import {showSheet} from '../../../../../actions/SheetActions';
import FabBackButton from '../../../../../components/fab-back-button/FabBackButton.componet';
import FieldHeader from '../../../../../components/fields/field-header/FieldHeader.component';
import ValidLabelField from '../../../../../components/fields/valid-label-field/ValidLabelField.component';
import PrimaryButton from '../../../../../components/primary-button/PrimaryButton.component';
import {useAuxiliary} from '../../../../../hooks/useValidations';
import {selectrootsheettype} from '../../../../../selectors/SheetSelector';
import styles from './AuxiliaryMobileSheet.style';
import fixNumbers from '../../../../../utils/FixNumbers';
import { selecetusertype } from '../../../../../selectors/User';

export default function AuxiliaryMobileSheet(props) {
  const {} = props;
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const translateY = useRef(new Animated.Value(421)).current;
  const [validationEnabled, setValidationEnabled] = useState(false);
  const {sheetId} = useSelector(state => selectrootsheettype(state));
  const auxiliaryState = useSelector(state => state?.app?.auxiliary);
  const {info} = useSelector(state => selecetusertype(state));


  useEffect(() => {
    switch (sheetId) {
      case 'auxiliaryMobile':
        Animated.timing(translateY, {
          toValue: 0,
          duration: 400,
          useNativeDriver: true,
        }).start();
        break;
      default:
        closeHandler();
        break;
    }
  }, [sheetId]);

  const closeHandler = () => {
    Animated.timing(translateY, {
      toValue: 421,
      duration: 400,
      useNativeDriver: true,
    }).start();
    setTimeout(() => {
      dispatch(showSheet({sheetId: ''}));
    }, 400);
  };

  const {
    value: auxiliary,
    setValue: setAuxiliary,
    result: auxiliaryValidation,
    checkError: auxiliaryCheckError,
  } = useAuxiliary(!validationEnabled);

  function onSubmit() {
    Keyboard.dismiss();
    if (auxiliaryCheckError()) {
      setValidationEnabled(true);
    } else {
      dispatch(getApp({auxiliary: auxiliary}));
      closeHandler();
    }
  }

  useEffect(()=>{
    if ( auxiliaryState ) {
      setAuxiliary(auxiliaryState)
    }else {
      setAuxiliary(info?.extra_phone_number)
    }
  },[])

  return (
    <>
      <TouchableOpacity
        activeOpacity={1}
        onPress={closeHandler}
        style={styles.container}
      />
      <Animated.View
        style={[{transform: [{translateY: translateY}]}, styles.content]}>
        <View style={styles.indicator} />
        <FabBackButton
          container_style={styles.closeBtn}
          onPress={closeHandler}
          icon={"closeIcon"}
        />
        <FieldHeader
          text={t('enter_auxiliary_number')}
          containerStyle={styles.title}
        />
        <ValidLabelField
          inputStyle={{
            flex: undefined,
          }}
          labelText={t('auxiliary_phone')}
          keyboardType="number-pad"
          maxLength={11}
          returnKeyType="done"
          onEndEditing={onSubmit}
          value={auxiliary}
          onChangeText={(text)=>setAuxiliary(fixNumbers(text))}
          isError={validationEnabled && auxiliaryCheckError()}
          errorText={auxiliaryValidation.error}
          {...props}
        />
        <PrimaryButton
          title={t('record')}
          containerStyle={styles.button}
          onPress={onSubmit}
        />
      </Animated.View>
    </>
  );
}
